import React, { FunctionComponent } from 'react';
import { SEOTextContent } from './SEOTextContent';
import ContentWrapper from '../../../components/ContentWrapper/ContentWrapper';
import { useQuerySEOText } from '../hooks/useQuerySEOText';

interface Props {
  requestUrl: string;
  queryOptions?: any;
  collapsed?: boolean;
  format?(html: string): string;
  iconClassName?: string;
  bodyClassName?: string;
  className?: string;
}

export const SEOText: FunctionComponent<Props> = ({
  requestUrl,
  queryOptions,
  collapsed = false,
  format = html => html,
  className,
  iconClassName,
  bodyClassName,
}) => {
  const { isSuccess, data } = useQuerySEOText(requestUrl, queryOptions);

  return isSuccess && data ? (
    <ContentWrapper
      collapsed={collapsed}
      className={className}
      bodyClassName={bodyClassName}
      iconClassName={iconClassName}
    >
      {/* @ts-ignore */}
      <SEOTextContent html={data} format={format} />
    </ContentWrapper>
  ) : null;
};
